export default __webpack_public_path__ + "static/media/03.fbb0cd5c.mp3";